<template>
  <div class="athlete-growth-page">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="header-left" @click="onClickLeft">
        <van-icon name="arrow-left" />
        <span>返回</span>
      </div>
      成长轨迹
      <a
        :href="
          routeValue === null ||
          routeValue === undefined ||
          routeValue.length === 0
            ? 'https://www.ptty.com.cn/wap/#/'
            : 'https://www.ptty.com.cn/wap/#/' + routeValue
        "
        class="header-right"
      >
        <van-icon name="wap-home" size="20" />
      </a>
    </div>

    <!-- 下拉刷新容器 -->
    <van-pull-refresh
      v-if="isHy === '1'"
      v-model="refreshing"
      @refresh="onRefresh"
      :disabled="!isAtTop"
      success-text="刷新成功"
      pulling-text="下拉即可刷新..."
      loosing-text="释放即可刷新..."
      loading-text="加载中.."
    >
      <!-- 球员选择区域 -->
      <div class="player-selection-section" v-if="isReceive === '0'">
        <div class="player-list-container">
          <div class="player-avatars">
            <!-- 已添加的球员头像 -->
            <div
              v-for="(player, index) in playerList"
              :key="index"
              class="player-avatar-item"
              :class="{ active: currentPlayerId === player.SFZH }"
              @click="switchPlayer(player.SFZH)"
            >
              <van-image
                round
                width="50px"
                height="50px"
                :src="
                  player.TXURL ||
                    'https://www.ptty.com.cn/wap/logo.png?v=20250530'
                "
                class="player-avatar"
              />
              <div class="player-name">{{ player.RYXM }}</div>
              <div
                v-if="currentPlayerId === player.SFZH"
                class="active-indicator"
              ></div>
              <!-- 删除按钮 -->
              <div
                class="delete-player-btn"
                @click.stop="confirmDeletePlayer(player)"
              >
                <van-icon name="cross" size="12px" />
              </div>
            </div>

            <!-- 添加新球员按钮 -->
            <div class="add-player-avatar" @click="addPlayer">
              <div class="add-avatar-btn">
                <van-icon name="plus" size="24px" />
              </div>
              <div class="add-player-text">添加球员</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="playerList.length > 0">
        <!-- 运动员基本信息卡片 -->
        <div class="athlete-info-card">
          <div class="avatar-section">
            <div class="avatar-container">
              <van-image
                round
                width="80px"
                height="80px"
                :src="
                  baseInfo.TXURL ||
                    'https://www.ptty.com.cn/wap/logo.png?v=20250530'
                "
              />
              <div class="status-dot active"></div>
            </div>
            <div class="info-text">
              <div class="name-row">
                <h3>{{ baseInfo.RYXM }}</h3>
                <div
                  class="edit-btn"
                  @click="editPlayerInfo"
                  v-if="isReceive === '0'"
                >
                  <van-icon name="edit" size="18px" />
                  <span>编辑</span>
                </div>
              </div>
              <div class="info-tags">
                <van-tag type="primary" size="small">{{
                  baseInfo.QYDJ
                }}</van-tag>
                <van-tag type="success" size="small">
                  {{ baseInfo.DQAGE }}年经验
                </van-tag>
              </div>
              <van-tag type="danger" size="small">
                比赛总时长：{{ formatDuration(baseInfo.BSYS) }}
              </van-tag>
              <p class="career-info">
                {{ baseInfo.XB === "M" ? "男" : "女" }} · {{ baseInfo.AGE }}岁·
                活跃状态
              </p>
            </div>
          </div>

          <!-- 比赛类型切换卡片 -->
          <div class="match-type-tabs">
            <div
              v-for="type in matchTypes"
              :key="type.key"
              :class="[
                'match-type-tab',
                { active: currentMatchType === type.key }
              ]"
              @click="switchMatchType(type.key)"
            >
              <div class="tab-icon">{{ type.icon }}</div>
              <div class="tab-label">{{ type.label }}</div>
              <div
                v-if="currentMatchType === type.key"
                class="tab-indicator"
              ></div>
            </div>
          </div>

          <!-- 成就统计 -->
          <div class="achievement-stats">
            <div class="stat-item">
              <div class="stat-icon">🏆</div>
              <div class="stat-number">
                {{ currentStats.ZDF === undefined ? 0 : currentStats.ZDF }}
              </div>
              <div class="stat-label">{{ currentMatchTypeLabel }}总得分</div>
            </div>
            <div class="stat-item success">
              <div class="stat-icon">🎯</div>
              <div class="stat-number">
                {{ currentStats.ZSC === undefined ? 0 : currentStats.ZSC }}
              </div>
              <div class="stat-label">{{ currentMatchTypeLabel }}胜场</div>
            </div>
            <div class="stat-item warning">
              <div class="stat-icon">📈</div>
              <div class="stat-number">
                {{
                  currentStats.SLV === undefined ? "0%" : currentStats.SLVNAME
                }}
              </div>
              <div class="stat-label">{{ currentMatchTypeLabel }}胜率</div>
            </div>
            <div class="stat-item info">
              <div class="stat-icon">⏱️</div>
              <div class="stat-number">
                {{
                  currentStats.CSZCHANGSHU === undefined
                    ? 0
                    : currentStats.CSZCHANGSHU
                }}
              </div>
              <div class="stat-label">{{ currentMatchTypeLabel }}比赛场数</div>
            </div>
            <div class="stat-item primary">
              <div class="stat-icon">⏳</div>
              <div class="stat-number">
                {{ formatDuration(currentStats.BSYS) }}
              </div>
              <div class="stat-label">{{ currentMatchTypeLabel }}比赛时长</div>
            </div>
            <div class="stat-item danger">
              <div class="stat-icon">👑</div>
              <div class="stat-number">
                {{
                  currentStats.TOPMC === undefined
                    ? "无名次"
                    : currentStats.TOPMC
                }}
              </div>
              <div class="stat-label">{{ currentMatchTypeLabel }}最好名次</div>
            </div>
          </div>
        </div>

        <!-- 年份筛选器 -->
        <div
          class="year-filter-section"
          style="margin-left: 14px;margin-right: 14px;"
        >
          <div class="year-filter-container">
            <div class="year-filter-scroll">
              <!-- 全部选项 -->
              <div
                :class="['year-item', { active: selectedYear === 'all' }]"
                @click="selectYear('all')"
              >
                <span class="year-text">全部</span>
                <div v-if="selectedYear === 'all'" class="year-indicator"></div>
              </div>
              <!-- 年份选项 -->
              <div
                v-for="year in availableYears"
                :key="year"
                :class="['year-item', { active: selectedYear === year }]"
                @click="selectYear(year)"
              >
                <span class="year-text">{{ year }}年</span>
                <div v-if="selectedYear === year" class="year-indicator"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 年度统计图表 -->
        <div class="yearly-stats">
          <div class="section-header">
            <h3 class="section-title">
              <van-icon name="bar-chart-o" />
              胜率趋势
            </h3>
            <div class="chart-legend">
              <div class="legend-item">
                <div class="legend-dot winrate"></div>
                <span>胜率</span>
              </div>
            </div>
          </div>

          <!-- 空数据提-->
          <div v-if="csMxData.length === 0" class="empty-chart">
            <div class="empty-icon">
              <van-icon name="chart-trending-o" size="48" color="#ccc" />
            </div>
            <div class="empty-text">暂无比赛数据</div>
          </div>

          <div v-else class="stats-chart">
            <canvas
              ref="statsCanvas"
              width="350"
              height="250"
              @touchstart="handleTouchStart($event, 'winrate')"
              @touchmove="handleTouchMove($event, 'winrate')"
              @touchend="handleTouchEnd('winrate')"
            ></canvas>
          </div>
        </div>

        <!-- 总得分趋势图-->
        <div class="yearly-stats">
          <div class="section-header">
            <h3 class="section-title">
              <van-icon name="bar-chart-o" />
              总得分趋势
            </h3>
            <div class="chart-legend">
              <div class="legend-item">
                <div class="legend-dot score"></div>
                <span>总得分</span>
              </div>
            </div>
          </div>

          <!-- 空数据提-->
          <div v-if="csMxData.length === 0" class="empty-chart">
            <div class="empty-icon">
              <van-icon name="chart-trending-o" size="48" color="#ccc" />
            </div>
            <div class="empty-text">暂无比赛数据</div>
          </div>

          <div v-else class="stats-chart">
            <canvas
              ref="scoreCanvas"
              width="350"
              height="250"
              @touchstart="handleTouchStart($event, 'score')"
              @touchmove="handleTouchMove($event, 'score')"
              @touchend="handleTouchEnd('score')"
            ></canvas>
          </div>
        </div>

        <!-- 胜场趋势图表 -->
        <div class="yearly-stats">
          <div class="section-header">
            <h3 class="section-title">
              <van-icon name="bar-chart-o" />
              胜场趋势
            </h3>
            <div class="chart-legend">
              <div class="legend-item">
                <div class="legend-dot wins"></div>
                <span>胜场</span>
              </div>
            </div>
          </div>

          <!-- 空数据提-->
          <div v-if="csMxData.length === 0" class="empty-chart">
            <div class="empty-icon">
              <van-icon name="chart-trending-o" size="48" color="#ccc" />
            </div>
            <div class="empty-text">暂无比赛数据</div>
          </div>

          <div v-else class="stats-chart">
            <canvas
              ref="winsCanvas"
              width="350"
              height="250"
              @touchstart="handleTouchStart($event, 'wins')"
              @touchmove="handleTouchMove($event, 'wins')"
              @touchend="handleTouchEnd('wins')"
            ></canvas>
          </div>
        </div>

        <!-- 成长轨迹-->
        <div class="growth-timeline">
          <div class="section-header">
            <h3 class="section-title">
              <van-icon name="chart-trending-o" />
              成长轨迹
            </h3>
          </div>

          <!-- 空数据提-->
          <div v-if="csMxData.length === 0" class="empty-timeline">
            <div class="empty-icon">
              <van-icon name="records" size="64" color="#ccc" />
            </div>
            <div class="empty-text">暂无成长轨迹数据</div>
            <div class="empty-hint">参加比赛后，这里将展示您的成长历程</div>
          </div>

          <div class="timeline-container" v-if="csMxData.length > 0">
            <div
              v-for="(item, index) in lbCsMxData"
              :key="index"
              class="timeline-item"
            >
              <div class="timeline-content">
                <!-- 参赛项目列表 -->
                <div class="achievement-details">
                  <div class="achievement-title">
                    <van-icon name="trophy-o" />
                    <span>参赛日期：{{ item.STARTDATE }}</span>
                  </div>
                  <div class="achievement-list">
                    <div
                      class="achievement-item"
                      @click="goToMatchDetail(item)"
                    >
                      <div class="achievement-icon">
                        <van-icon name="medal-o" size="16" />
                      </div>
                      <div class="achievement-content">
                        <div class="achievement-name">{{ item.SSMC }}</div>
                      </div>
                      <div class="achievement-arrow">
                        <van-icon name="arrow" size="14" color="#999" />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-for="(mxItem, mxIndex) in item.CONTENT" :key="mxIndex">
                  <div class="achievement-title">
                    <van-icon name="trophy-o" />
                    <span>{{ mxItem.SSLXMC }}统计</span>
                  </div>
                  <div class="content-header">
                    <h4 v-if="mxItem.BZMC === '1'" class="rank-title">
                      <span class="rank-icon gold-medal">🥇</span>
                      冠军
                    </h4>
                    <h4 v-if="mxItem.BZMC === '2'" class="rank-title">
                      <span class="rank-icon silver-medal">🥈</span>
                      亚军
                    </h4>
                    <h4 v-if="mxItem.BZMC === '3'" class="rank-title">
                      <span class="rank-icon bronze-medal">🥉</span>
                      季军
                    </h4>
                    <h4 v-if="mxItem.BZMC && mxItem.BZMC.indexOf('-') > -1">
                      并列{{ mxItem.BZMC }}
                    </h4>
                    <h4 v-if="mxItem.BZMC === '未取得名次'">继续加油</h4>
                  </div>

                  <!-- 数据统计卡片 -->
                  <div class="stats-summary">
                    <div class="stats-summary-item">
                      <span class="stats-label">总得分</span>
                      <span class="stats-value highlight-primary">{{
                        mxItem.ZDF
                      }}</span>
                      <span class="stats-unit">分</span>
                    </div>
                    <div class="stats-summary-item">
                      <span class="stats-label">总胜场</span>
                      <span class="stats-value highlight-success">{{
                        mxItem.ZSC
                      }}</span>
                      <span class="stats-unit">场</span>
                    </div>
                    <div class="stats-summary-item">
                      <span class="stats-label">胜率</span>
                      <span class="stats-value highlight-warning">{{
                        mxItem.SLV
                      }}</span>
                    </div>
                    <div class="stats-summary-item">
                      <span class="stats-label">总场数</span>
                      <span class="stats-value highlight-info">{{
                        mxItem.CSZCHANGSHU
                      }}</span>
                      <span class="stats-unit">场</span>
                    </div>
                    <div class="stats-summary-item">
                      <span class="stats-label">比赛时长</span>
                      <span class="stats-value highlight-primary">{{
                        formatDuration(mxItem.BSYS)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <!-- 返回顶部悬浮按钮 -->
    <transition name="fade-scale">
      <div v-show="showBackTop" class="back-to-top-fab" @click="scrollToTop">
        <div class="fab-icon">
          <van-icon name="arrow-up" size="20" />
        </div>
        <div class="fab-text">顶部</div>
      </div>
    </transition>

    <!-- 会员推广横幅 -->
    <div
      v-if="isHy === '0'"
      class="vip-promotion-banner"
      @click="goToMemberBenefits"
    >
      <div class="vip-banner-bg">
        <div class="vip-banner-content">
          <div class="vip-icon-wrapper">
            <van-icon name="vip-card" size="32" class="vip-icon" />
            <div class="vip-sparkle">✨</div>
          </div>
          <div class="vip-text-content">
            <div class="vip-title">
              <span class="vip-highlight">办会员</span>
              <span class="vip-separator">·</span>
              <span class="vip-highlight">看生涯</span>
            </div>
            <div class="vip-subtitle">开通会员即可查看完整生涯数据</div>
          </div>
          <div class="vip-arrow">
            <van-icon name="arrow" size="18" />
          </div>
        </div>
        <div class="vip-banner-shine"></div>
      </div>
    </div>

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
export default {
  components: { LoadingCom },
  name: "MeQygjIndex",
  data() {
    return {
      refreshing: false, // 下拉刷新状
      showBackTop: false, // 显示返回顶部按钮
      isHy: "1", // 会员状态，默认为非会员
      routeValue: "", // 路由值
      uis: {},
      // 球员列表数据
      playerList: [],
      baseInfo: {},
      currentPlayerId: 1, // 当前选中的球员ID
      trialBaseInfo: {}, //总数
      nowYearInfo: {}, //本年数据
      csMxData: [], //参赛明细数据给统计曲线图用的
      lbCsMxData: [],
      // 比赛类型切换
      currentMatchType: "single", // 当前选中的比赛类型：all(全部)、single(单打)、double(双打)、team(团体)
      matchTypes: [
        { key: "single", label: "单打", icon: "🎾" },
        { key: "double", label: "双打", icon: "🤝" }
        // ,
        // { key: "team", label: "团体", icon: "👥" }
      ],
      // 各类型的统计数据
      matchTypeStats: {
        single: {}, // 单打数据
        double: {}, // 双打数据
        team: {} // 团体数据
      },
      // 比赛历史数据
      matchHistory: [],
      growthMilestones: [],
      selectedYear: new Date().getFullYear(), // 当前选中的年
      availableYears: [], // 可选择的年份列
      // 图表交互数据 - 胜率
      currentMatchData: null,
      chartPadding: 0,
      chartStepX: 0,
      chartHeight: 0,
      // 图表交互数据 - 总得
      currentScoreData: null,
      scoreChartPadding: 0,
      scoreChartStepX: 0,
      scoreChartHeight: 0,
      // 图表交互数据 - 胜场
      currentWinsData: null,
      winsChartPadding: 0,
      winsChartStepX: 0,
      winsChartHeight: 0,
      reqSfzh: "",
      isReceive: "0",
      isAtTop: true // 是否在顶部
    };
  },

  computed: {
    // 当前选中的球员信
    currentPlayer() {
      return (
        this.playerList.find(player => player.id === this.currentPlayerId) ||
        null
      );
    },
    // 当前比赛类型的统计数
    currentStats() {
      // 如果有对应类型的数据，返回该类型数据，否则返回总数
      const typeStats = this.matchTypeStats[this.currentMatchType];
      if (typeStats && Object.keys(typeStats).length > 0) {
        return typeStats;
      }
      return this.trialBaseInfo;
    },
    // 当前比赛类型的标
    currentMatchTypeLabel() {
      const labels = {
        all: "",
        single: "单打",
        double: "双打",
        team: "团体"
      };
      return labels[this.currentMatchType] || "";
    },
    // 计算比赛时长
    matchDuration() {
      const matchCount = this.currentStats.CSZCHANGSHU || 0;
      if (matchCount === 0) return "0小时";

      // 假设每场比赛平均时长为1.5小时
      const totalHours = Math.round(matchCount * 1.5);

      if (totalHours < 24) {
        return `${totalHours}小时`;
      } else {
        const days = Math.floor(totalHours / 24);
        const hours = totalHours % 24;
        return hours > 0 ? `${days}天${hours}小时` : `${days}天`;
      }
    },
    latestYearData() {
      return this.matchHistory[this.matchHistory.length - 1] || {};
    },
    previousYearData() {
      return this.matchHistory[this.matchHistory.length - 2] || {};
    },
    displayMilestones() {
      return this.growthMilestones.slice(-3); // 只显示最个里程碑
    }
  },
  created() {
    this.utilPost = this.$util.handler;
    this.initYearList(); // 初始化年份列
    var sfzh = this.$route.query.sfzh;
    if (sfzh !== undefined) {
      this.reqSfzh = sfzh;
      this.isReceive = "1";
    }
    // alert(sfzh);
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    // const openIdEn = localStorage.getItem("openIdEn");
    // if (!openIdEn) {
    //   this.$router.push("/loginIndex");
    //   return;
    // }
    // const ryInfoLocal = localStorage.getItem("ryInfo");
    // if (!ryInfoLocal) this.$router.push("/loginIndex");
    this.checkLogin();
    this.updateAthleteInfo(); // 初始化时更新运动员信
    this.initAthleteData();
    this.generateGrowthMilestones();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      this.getPlayerList();

      // 延迟调用一次，用测试数据绘制图
      setTimeout(() => {
        console.log("Calling all chart methods from mounted with test data");
        this.drawStatsChart();
        this.drawScoreChart();
        this.drawWinsChart();
      }, 1000);
    });
  },

  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    checkLogin() {
      var openIdEn = localStorage.getItem("openIdEn");
      if (
        openIdEn === undefined ||
        openIdEn === null ||
        openIdEn.length === 0
      ) {
        var that = this;
        this.utilPost.getOpenId(function(openId) {
          var ryInfoLocal = localStorage.getItem("ryInfo");
          if (
            ryInfoLocal === undefined ||
            ryInfoLocal === "" ||
            ryInfoLocal === null ||
            ryInfoLocal.length === 0
          ) {
            that.$router.push({ path: "/loginIndex" });
            return;
          } else {
            this.uis = ryInfoLocal;
          }
        });
      } else {
        var ryInfoLocal = localStorage.getItem("ryInfo");
        if (
          ryInfoLocal === undefined ||
          ryInfoLocal === "" ||
          ryInfoLocal === null ||
          ryInfoLocal.length === 0
        ) {
          this.$router.push({ path: "/loginIndex" });
        } else {
          this.uis = ryInfoLocal;
        }
      }
      this.openIdEn = openIdEn;
    },
    // 处理滚动事件
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.showBackTop = scrollTop > 300;
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop = scrollTop <= 10;
    },
    // 返回顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    // 格式化时长显示
    formatDuration(minutes) {
      // 如果未定义或为0，返回0分钟
      if (minutes === undefined || minutes === null || minutes === 0) {
        return "0分钟";
      }

      // 如果小于60分钟，显示分钟
      if (minutes < 60) {
        return `${minutes}分钟`;
      }

      // 如果大于等于60分钟，转换为小时
      const hours = (minutes / 60).toFixed(1);
      return `${hours}小时`;
    },

    // 计算比赛时长
    calculateMatchDuration(matchCount) {
      if (!matchCount || matchCount === 0) return "0小时";

      // 假设每场比赛平均时长为1.5小时
      const totalHours = Math.round(matchCount * 1.5);

      if (totalHours < 24) {
        return `${totalHours}小时`;
      } else {
        const days = Math.floor(totalHours / 24);
        const hours = totalHours % 24;
        return hours > 0 ? `${days}天${hours}小时` : `${days}天`;
      }
    },

    // 切换比赛类型
    switchMatchType(type) {
      this.currentMatchType = type;

      this.getCzgjPlayer();
    },

    // 加载对应比赛类型的数
    loadMatchTypeData(type) {
      // 如果已经有该类型的数据，直接返回
      if (
        this.matchTypeStats[type] &&
        Object.keys(this.matchTypeStats[type]).length > 0
      ) {
        return;
      }

      // 调用后端接口获取对应类型的数
      const busData = {
        SFZH: this.baseInfo.SFZH,
        matchType: type // single, double, team
      };
      const paramData = {
        headerData: {
          ssid: "",
          op: "wapGL",
          methodName: "getCzgjPlayerByType"
        },
        busData: busData
      };

      this.utilPost.paramData = paramData;
      this.utilPost
        .sendPost()
        .then(data => {
          if (!data.isSuccess) {
            // 如果接口失败，使用总数据作为默认
            this.$set(this.matchTypeStats, type, this.trialBaseInfo);
            return;
          }
          // 保存对应类型的数
          this.$set(
            this.matchTypeStats,
            type,
            data.content.trialBaseInfo || {}
          );
        })
        .catch(error => {
          console.error("加载比赛类型数据失败:", error);
          // 使用总数据作为默认
          this.$set(this.matchTypeStats, type, this.trialBaseInfo);
        });
    },

    // 初始化年份列
    initYearList() {
      const currentYear = new Date().getFullYear();
      const startYear = 2023;
      this.availableYears = [];

      // 从当前年份到2023年（倒序，最大年份在前）
      for (let year = currentYear; year >= startYear; year--) {
        this.availableYears.push(year);
      }

      // 默认选中"全部"
      this.selectedYear = "all";
    },

    // 选择年份
    selectYear(year) {
      this.selectedYear = year;

      this.getCzgjPlayer();
    },

    // 下拉刷新处理
    onRefresh() {
      // 重新加载数据
      if (this.playerList.length > 0 && this.currentPlayerId) {
        this.getCzgjPlayer();
      } else {
        this.getPlayerList();
      }

      // 模拟刷新延迟，确保用户能看到刷新动画
      setTimeout(() => {
        this.refreshing = false;
        this.$toast.success("刷新成功");
      }, 500);
    },
    getPlayerList() {
      var busData = {
        reqSfzh: this.reqSfzh
      };
      var paramData = {
        headerData: {
          ssid: "",
          op: this.op, //反射名称
          methodName: "playerList" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          this.refreshing = false;
          return;
        }
        this.isHy = data.lsData.isHy;
        this.playerList = data.content;
        if (this.playerList.length > 0) {
          this.currentPlayerId = this.playerList[0].SFZH;
          this.baseInfo = this.playerList[0];
          this.getCzgjPlayer();
        }
        this.refreshing = false;
      });
    },
    getCzgjPlayer() {
      // alert(this.currentMatchType);
      // alert(this.selectedYear);
      //"single", // 当前选中的比赛类型：single(单打)、double(双打)、team(团体)
      var busData = {
        SFZH: this.baseInfo.SFZH,
        SSLXTYPE: this.currentMatchType,
        year: this.selectedYear
      };
      var paramData = {
        headerData: {
          ssid: "",
          op: this.op, //反射名称
          methodName: "getCzgjPlayer" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          this.refreshing = false;
          return;
        }
        this.trialBaseInfo = data.content.trialBaseInfo;
        this.lbCsMxData = data.content.csMxData;
        var copyMxData = JSON.parse(JSON.stringify(this.lbCsMxData));
        this.csMxData = copyMxData.reverse();

        console.log("🔄 getCzgjPlayer completed");
        console.log("📦 trialBaseInfo:", this.trialBaseInfo);
        console.log("📦 csMxData:", this.csMxData);

        // 初始化各类型数据（如果后端返回了分类数据
        if (data.content.matchTypeStats) {
          this.matchTypeStats = data.content.matchTypeStats;
        } else {
          // 如果后端没有返回分类数据，将总数据作为默认
          this.matchTypeStats = {
            all: this.trialBaseInfo,
            single: this.trialBaseInfo,
            double: {},
            team: {}
          };
        }

        this.refreshing = false;

        // 数据加载完成后重新绘制图
        console.log("Data loaded, about to draw charts");
        this.$nextTick(() => {
          console.log("In nextTick, calling draw chart methods");
          setTimeout(() => {
            console.log("In timeout, calling all chart methods");
            this.drawStatsChart();
            this.drawScoreChart();
            this.drawWinsChart();
          }, 200);
        });
      });
    },
    getInfoPlayer() {},
    onClickLeft() {
      this.$router.go(-1);
    },
    // 跳转到会员权益页面
    goToMemberBenefits() {
      this.$router.push("/memberBenefits");
    },

    shareProfile() {
      this.$toast("分享功能开发中...");
    },

    // 编辑运动员信息
    editPlayerInfo() {
      // 跳转到添加人员页面，传递编辑模式参数
      this.$router.push({
        path: "/addPlayer",
        query: {
          mode: "edit",
          sfzh: this.baseInfo.SFZH,
          ryxm: this.baseInfo.RYXM,
          txurl: this.baseInfo.TXURL,
          xb: this.baseInfo.XB,
          age: this.baseInfo.AGE,
          qydj: this.baseInfo.QYDJ,
          ryid: this.baseInfo.RYID
        }
      });
    },

    // 添加新球
    addPlayer() {
      this.$router.push("/addPlayer");
      return;
    },

    // 切换选中的球
    switchPlayer(playerId) {
      console.log("切换球员:", playerId);
      this.currentPlayerId = playerId;
      this.updateAthleteInfo();

      const player = this.playerList.find(p => p.SFZH === playerId);
      if (player) {
        this.baseInfo = player;
        this.getCzgjPlayer();
        this.$toast(`已切换到: ${player.RYXM}`);
      }
    },

    // 确认删除球员
    confirmDeletePlayer(player) {
      this.$dialog
        .confirm({
          title: "删除球员",
          message: `确定要删除球${player.RYXM}"吗？删除后将无法恢复。`,
          confirmButtonText: "确定删除",
          confirmButtonColor: "#ee0a24",
          cancelButtonText: "取消"
        })
        .then(() => {
          this.deletePlayer(player);
        })
        .catch(() => {
          // 用户取消删除
        });
    },

    // 删除球员
    deletePlayer(player) {
      const busData = {
        RYID: player.RYID,
        type: "DEL"
      };
      const paramData = {
        headerData: {
          ssid: "",
          op: "wapGL",
          methodName: "addPlayer"
        },
        busData: busData
      };

      this.utilPost.paramData = paramData;
      this.utilPost
        .sendPost()
        .then(data => {
          if (!data.isSuccess) {
            this.$toast.fail(data.msg || "删除失败");
            return;
          }

          this.$toast.success("删除成功");

          // 从列表中移除该球
          const index = this.playerList.findIndex(p => p.SFZH === player.SFZH);
          if (index > -1) {
            this.playerList.splice(index, 1);
          }

          // 如果删除的是当前选中的球员，切换到第一个球
          if (this.currentPlayerId === player.SFZH) {
            if (this.playerList.length > 0) {
              this.currentPlayerId = this.playerList[0].SFZH;
              this.baseInfo = this.playerList[0];
              this.getCzgjPlayer();
            } else {
              // 没有球员了，清空数据
              this.currentPlayerId = null;
              this.baseInfo = {};
              this.trialBaseInfo = {};
              this.nowYearInfo = {};
              this.csMxData = [];
            }
          }
        })
        .catch(error => {
          console.error("删除球员失败:", error);
          this.$toast.fail("删除失败，请重试");
        });
    },

    // 跳转到比赛详情页
    goToMatchDetail(matchItem) {
      // 将比赛信息存储到 localStorage
      const matchInfo = {
        SSMC: matchItem.SSMC, // 赛事名称
        SSLXMC: matchItem.SSLXMC, // 赛事类型名称
        SSID: matchItem.SSID || "", // 赛事ID
        XMID: matchItem.XMID || "", // 项目ID
        fromGrowth: true // 标记来自成长轨迹页面
      };

      localStorage.setItem("selectedMatch", JSON.stringify(matchInfo));

      // 跳转到实时比分页
      this.$router.push({
        path: "/ssbfIndex",
        query: {
          ssid: matchItem.SSIDEN
        }
      });
    },

    // 更新运动员信息显
    updateAthleteInfo() {
      const currentPlayer = this.currentPlayer;
      if (currentPlayer) {
        this.athleteInfo = { ...currentPlayer };
      }
    },

    // 初始化运动员数据
    initAthleteData() {
      const totalMatches = this.matchHistory.reduce(
        (sum, year) => sum + year.totalMatches,
        0
      );
      const totalWins = this.matchHistory.reduce(
        (sum, year) => sum + year.wins,
        0
      );
      const totalLosses = this.matchHistory.reduce(
        (sum, year) => sum + year.losses,
        0
      );
      const totalChampionships = this.matchHistory.reduce(
        (sum, year) => sum + year.championships,
        0
      );
      const overallWinRate =
        totalMatches > 0 ? Math.round((totalWins / totalMatches) * 100) : 0;

      this.athleteInfo = {
        ...this.athleteInfo,
        totalMatches,
        wins: totalWins,
        losses: totalLosses,
        winRate: overallWinRate,
        championships: totalChampionships,
        ranking: this.getCurrentRanking()
      };
    },

    // 生成成长轨迹
    generateGrowthMilestones() {
      this.growthMilestones = this.matchHistory.map((yearData, index) => {
        const isActive = index === this.matchHistory.length - 1;
        const category = this.getCategoryByYear(yearData.year);
        const type = this.getTypeByWinRate(yearData.winRate);
        const icon = this.getIconByCategory(category);
        const title = this.getTitleByAchievements(yearData.achievements);
        const description = this.getDescriptionByYear(yearData);

        return {
          date: `${yearData.year}年`,
          title,
          category,
          type,
          icon,
          description,
          isActive,
          achievements: yearData.achievements.map((achievement, i) => ({
            id: index * 10 + i + 1,
            title: achievement,
            rank: this.extractRankFromAchievement(achievement)
          })),
          skills: this.generateSkillsByYear(yearData, index)
        };
      });
    },

    getCategoryByYear(year) {
      if (year <= 2020) return "基础训练";
      if (year <= 2021) return "技能提";
      if (year <= 2022) return "职业发展";
      return "巅峰状";
    },

    getTypeByWinRate(winRate) {
      if (winRate >= 80) return "danger";
      if (winRate >= 75) return "warning";
      return "success";
    },

    getIconByCategory(category) {
      const icons = {
        基础训练: "star-o",
        技能提: "medal-o",
        职业发展: "fire-o",
        巅峰状态: "trophy-o"
      };
      return icons[category] || "star-o";
    },

    getTitleByAchievements(achievements) {
      // const hasChampion = achievements.some(achievement =>
      //   achievement.includes("冠军")
      // );
      // if (hasChampion) return "获得重要冠军";

      // const hasTop3 = achievements.some(
      //   achievement =>
      //     achievement.includes(") ||
      //     achievement.includes(") ||
      //     achievement.includes(")
      // );
      // if (hasTop3) return "进入前三;

      return "比赛成绩提升";
    },

    getDescriptionByYear(yearData) {
      const winRate = yearData.winRate;
      const totalMatches = yearData.totalMatches;

      if (winRate >= 80) {
        return `${yearData.year}年表现卓越，胜率达到${winRate}%，在${totalMatches}场比赛中展现出色竞技水平`;
      } else if (winRate >= 75) {
        return `${yearData.year}年表现优秀，胜{winRate}%，参{totalMatches}场比赛，成绩稳步提升`;
      } else {
        return `${yearData.year}年参{totalMatches}场比赛，胜率${winRate}%，积累宝贵比赛经验`;
      }
    },

    extractRankFromAchievement(achievement) {
      // if (achievement.includes("冠军")) return "🥇";
      // if (achievement.includes(")) return "🥈";
      // if (achievement.includes(")) return "🥉";
      // if (achievement.includes(")) return ";
      // if (achievement.includes(")) return ";
      // if (achievement.includes(")) return ";
      // return "参与";
    },

    generateSkillsByYear(yearData, yearIndex) {},

    getCurrentRanking() {},

    // 绘制统计图表
    drawStatsChart() {
      console.log("=== drawStatsChart called ===");
      console.log("🔍 this.csMxData:", this.csMxData);
      console.log("🔍 csMxData is array", Array.isArray(this.csMxData));
      console.log(
        "🔍 csMxData length:",
        this.csMxData ? this.csMxData.length : "undefined"
      );

      const canvas = this.$refs.statsCanvas;

      if (!canvas) {
        console.log("Canvas not found");
        return;
      }

      console.log("Canvas found:", canvas.width, "x", canvas.height);

      const ctx = canvas.getContext("2d");

      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let matchData = [];

      // csMxData 提取真实数据，使用胜率字
      if (this.csMxData && this.csMxData.length > 0) {
        console.log("📊 Processing real data from csMxData...");

        // 添加起始点（0%
        matchData.push({
          label: "起点",
          winRate: 0,
          isStart: true
        });

        this.csMxData.forEach((item, index) => {
          console.log(`  Processing item ${index}:`, item);

          if (item.CONTENT && item.CONTENT.length > 0) {
            item.CONTENT.forEach((content, contentIndex) => {
              // 直接使用 SLV 字段（胜率）
              let winRate = 0;
              if (content.SLV) {
                // SLV 可能是字符串 "85.7%" 或数85.7
                const slvStr = content.SLV.toString();
                winRate = parseFloat(slvStr.replace("%", "")) || 0;
              }

              const matches = parseInt(content.CSZCHANGSHU) || 0;
              const wins = parseInt(content.ZSC) || 0;

              console.log(
                `    Content ${contentIndex}: SLV=${content.SLV}, winRate=${winRate}%, wins=${wins}, matches=${matches}`
              );

              // 格式化日期为 yy-MM
              let dateLabel = "";
              if (item.STARTDATE) {
                const dateStr = item.STARTDATE;
                // STARTDATE 格式可能"2025-01-15" 或其他格
                const dateParts = dateStr.split("-");
                if (dateParts.length >= 2) {
                  const year = dateParts[0].substring(2); // 取后两位
                  const month = dateParts[1];
                  dateLabel = `${year}-${month}`;
                } else {
                  dateLabel = dateStr.substring(0, 5); // 备用方案
                }
              } else {
                dateLabel = `比赛${index + 1}`;
              }

              matchData.push({
                label: dateLabel,
                winRate: winRate,
                totalMatches: matches,
                totalWins: wins
              });

              console.log(
                `    Added point: ${dateLabel}, winRate=${winRate.toFixed(
                  1
                )}%, wins=${wins}, matches=${matches}`
              );
            });
          }
        });

        console.log(
          `📊 Extracted ${matchData.length} data points from real data (including start point)`
        );
      }

      // 如果没有真实数据，使用测试数
      if (matchData.length === 0) {
        console.log("📊 No real data, creating test data...");
        matchData = [
          { label: "起点", winRate: 0, isStart: true },
          { label: "25-01", winRate: 45.5, totalWins: 5, totalMatches: 11 },
          { label: "25-02", winRate: 52.3, totalWins: 11, totalMatches: 21 },
          { label: "25-03", winRate: 58.7, totalWins: 17, totalMatches: 29 },
          { label: "25-04", winRate: 65.2, totalWins: 23, totalMatches: 35 },
          { label: "25-05", winRate: 72.8, totalWins: 29, totalMatches: 40 },
          { label: "25-06", winRate: 78.5, totalWins: 35, totalMatches: 45 },
          { label: "25-07", winRate: 82.3, totalWins: 41, totalMatches: 50 },
          { label: "25-08", winRate: 75.6, totalWins: 45, totalMatches: 60 },
          { label: "25-09", winRate: 80.1, totalWins: 52, totalMatches: 65 },
          { label: "25-10", winRate: 85.7, totalWins: 60, totalMatches: 70 }
        ];
        console.log("📊 Test data created with", matchData.length, "points");
      }

      console.log("📈 Final matchData:", matchData);
      console.log("📈 matchData.length:", matchData.length);

      if (matchData.length === 0) {
        console.log("No match data to draw");
        return;
      }

      const padding = 60;
      const chartWidth = canvas.width - 2 * padding;
      const chartHeight = canvas.height - 2 * padding;

      // 绘制背景
      ctx.fillStyle = "#fafafa";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 绘制网格和Y轴标
      ctx.strokeStyle = "#e8e8e8";
      ctx.lineWidth = 1;
      ctx.fillStyle = "#999";
      ctx.font = "12px Arial";
      ctx.textAlign = "right";

      for (let i = 0; i <= 5; i++) {
        const y = padding + (chartHeight / 5) * i;
        // 网格
        ctx.beginPath();
        ctx.moveTo(padding, y);
        ctx.lineTo(canvas.width - padding, y);
        ctx.stroke();
        // Y轴标
        const value = 100 - i * 20;
        ctx.fillText(value + "%", padding - 10, y + 4);
      }

      console.log("Grid drawn");

      // 如果只有一个数据点
      if (matchData.length === 1) {
        console.log("⚠️ Only ONE data point, drawing single point");
        const x = canvas.width / 2;
        const winRate = matchData[0].winRate;
        const y = canvas.height - padding - (winRate / 100) * chartHeight;

        // 绘制节点
        ctx.fillStyle = "#185f9b";
        ctx.beginPath();
        ctx.arc(x, y, 6, 0, 2 * Math.PI);
        ctx.fill();

        // 标签
        ctx.fillStyle = "#185f9b";
        ctx.font = "14px Arial";
        ctx.textAlign = "center";
        ctx.fillText(winRate.toFixed(1) + "%", x, y - 15);

        // X轴标
        ctx.fillStyle = "#666";
        ctx.font = "12px Arial";
        ctx.fillText(matchData[0].label, x, canvas.height - padding + 20);

        console.log("Single point drawn");
        return;
      }

      console.log("Multiple points detected:", matchData.length);

      // 多个数据
      const stepX = chartWidth / (matchData.length - 1);
      console.log(
        "📏 Step X:",
        stepX,
        "= chartWidth:",
        chartWidth,
        "/ (length - 1):",
        matchData.length - 1
      );

      // 绘制填充区域
      const gradient = ctx.createLinearGradient(
        0,
        padding,
        0,
        canvas.height - padding
      );
      gradient.addColorStop(0, "rgba(24, 95, 155, 0.2)");
      gradient.addColorStop(1, "rgba(24, 95, 155, 0.05)");

      ctx.beginPath();
      matchData.forEach((data, index) => {
        const x = padding + stepX * index;
        const y = canvas.height - padding - (data.winRate / 100) * chartHeight;
        console.log(
          `  Point ${index}: x=${x}, y=${y}, winRate=${data.winRate}%`
        );
        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });
      const lastX = padding + stepX * (matchData.length - 1);
      ctx.lineTo(lastX, canvas.height - padding);
      ctx.lineTo(padding, canvas.height - padding);
      ctx.closePath();
      ctx.fillStyle = gradient;
      ctx.fill();

      console.log("Fill area drawn");

      // 绘制曲线
      ctx.beginPath();
      matchData.forEach((data, index) => {
        const x = padding + stepX * index;
        const y = canvas.height - padding - (data.winRate / 100) * chartHeight;
        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });
      ctx.strokeStyle = "#185f9b";
      ctx.lineWidth = 3;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.stroke();

      console.log("Line drawn");

      // 不再默认绘制节点和标签，改为触摸时显
      // 保存 matchData 到实例，供触摸事件使
      this.currentMatchData = matchData;
      this.chartPadding = padding;
      this.chartStepX = stepX;
      this.chartHeight = chartHeight;

      // X轴标
      ctx.fillStyle = "#666";
      ctx.font = "10px Arial";
      ctx.textAlign = "center";
      matchData.forEach((data, index) => {
        const x = padding + stepX * index;
        const y = canvas.height - padding + 20;
        ctx.fillText(data.label, x, y);
      });

      console.log("Labels drawn");
      console.log("=== drawStatsChart completed successfully ===");
    },

    // 绘制总得分图
    drawScoreChart() {
      console.log("=== drawScoreChart called ===");

      const canvas = this.$refs.scoreCanvas;

      if (!canvas) {
        console.log("Score canvas not found");
        return;
      }

      const ctx = canvas.getContext("2d");

      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let scoreData = [];

      // csMxData 提取总得分数
      if (this.csMxData && this.csMxData.length > 0) {
        console.log("📊 Processing score data from csMxData...");

        // 添加起始点（0分）
        scoreData.push({
          label: "起点",
          score: 0,
          isStart: true
        });

        this.csMxData.forEach((item, index) => {
          if (item.CONTENT && item.CONTENT.length > 0) {
            item.CONTENT.forEach(content => {
              const score = parseInt(content.ZDF) || 0;

              // 格式化日期为 yy-MM
              let dateLabel = "";
              if (item.STARTDATE) {
                const dateStr = item.STARTDATE;
                const dateParts = dateStr.split("-");
                if (dateParts.length >= 2) {
                  const year = dateParts[0].substring(2);
                  const month = dateParts[1];
                  dateLabel = `${year}-${month}`;
                } else {
                  dateLabel = dateStr.substring(0, 5);
                }
              } else {
                dateLabel = `比赛${index + 1}`;
              }

              scoreData.push({
                label: dateLabel,
                score: score
              });
            });
          }
        });
      }

      // 如果没有真实数据，使用测试数
      if (scoreData.length === 0) {
        scoreData = [
          { label: "起点", score: 0, isStart: true },
          { label: "25-01", score: 120 },
          { label: "25-02", score: 245 },
          { label: "25-03", score: 380 },
          { label: "25-04", score: 520 },
          { label: "25-05", score: 680 },
          { label: "25-06", score: 850 },
          { label: "25-07", score: 1020 },
          { label: "25-08", score: 1150 },
          { label: "25-09", score: 1320 },
          { label: "25-10", score: 1500 }
        ];
      }

      if (scoreData.length === 0) return;

      const padding = 60;
      const chartWidth = canvas.width - 2 * padding;
      const chartHeight = canvas.height - 2 * padding;

      // 绘制背景
      ctx.fillStyle = "#fafafa";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 计算最大值用于Y轴刻
      const maxScore = Math.max(...scoreData.map(d => d.score));
      const yAxisMax = Math.ceil(maxScore / 100) * 100 || 100; // 向上取整00的倍数，最00

      // 绘制网格和Y轴标
      ctx.strokeStyle = "#e8e8e8";
      ctx.lineWidth = 1;
      ctx.fillStyle = "#999";
      ctx.font = "12px Arial";
      ctx.textAlign = "right";

      for (let i = 0; i <= 5; i++) {
        const y = padding + (chartHeight / 5) * i;
        ctx.beginPath();
        ctx.moveTo(padding, y);
        ctx.lineTo(canvas.width - padding, y);
        ctx.stroke();
        const value = yAxisMax - (i * yAxisMax) / 5;
        ctx.fillText(Math.round(value).toString(), padding - 10, y + 4);
      }

      // 如果只有一个数据点
      if (scoreData.length === 1) {
        const x = canvas.width / 2;
        const score = scoreData[0].score;
        const y = canvas.height - padding - (score / yAxisMax) * chartHeight;

        ctx.fillStyle = "#f59e0b";
        ctx.beginPath();
        ctx.arc(x, y, 6, 0, 2 * Math.PI);
        ctx.fill();

        ctx.fillStyle = "#666";
        ctx.font = "12px Arial";
        ctx.textAlign = "center";
        ctx.fillText(scoreData[0].label, x, canvas.height - padding + 20);
        return;
      }

      // 多个数据
      const stepX = chartWidth / (scoreData.length - 1);

      // 绘制填充区域
      const gradient = ctx.createLinearGradient(
        0,
        padding,
        0,
        canvas.height - padding
      );
      gradient.addColorStop(0, "rgba(245, 158, 11, 0.2)");
      gradient.addColorStop(1, "rgba(245, 158, 11, 0.05)");

      ctx.beginPath();
      scoreData.forEach((data, index) => {
        const x = padding + stepX * index;
        const y =
          canvas.height - padding - (data.score / yAxisMax) * chartHeight;
        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });
      const lastX = padding + stepX * (scoreData.length - 1);
      ctx.lineTo(lastX, canvas.height - padding);
      ctx.lineTo(padding, canvas.height - padding);
      ctx.closePath();
      ctx.fillStyle = gradient;
      ctx.fill();

      // 绘制曲线
      ctx.beginPath();
      scoreData.forEach((data, index) => {
        const x = padding + stepX * index;
        const y =
          canvas.height - padding - (data.score / yAxisMax) * chartHeight;
        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });
      ctx.strokeStyle = "#f59e0b";
      ctx.lineWidth = 3;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.stroke();

      // 保存数据供触摸事件使
      this.currentScoreData = scoreData;
      this.scoreChartPadding = padding;
      this.scoreChartStepX = stepX;
      this.scoreChartHeight = chartHeight;

      // X轴标
      ctx.fillStyle = "#666";
      ctx.font = "10px Arial";
      ctx.textAlign = "center";
      scoreData.forEach((data, index) => {
        const x = padding + stepX * index;
        const y = canvas.height - padding + 20;
        ctx.fillText(data.label, x, y);
      });

      console.log("=== drawScoreChart completed ===");
    },

    // 绘制胜场图表
    drawWinsChart() {
      console.log("=== drawWinsChart called ===");

      const canvas = this.$refs.winsCanvas;

      if (!canvas) {
        console.log("Wins canvas not found");
        return;
      }

      const ctx = canvas.getContext("2d");

      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let winsData = [];

      // csMxData 提取胜场数据
      if (this.csMxData && this.csMxData.length > 0) {
        console.log("📊 Processing wins data from csMxData...");

        // 添加起始点（0场）
        winsData.push({
          label: "起点",
          wins: 0,
          isStart: true
        });

        this.csMxData.forEach((item, index) => {
          if (item.CONTENT && item.CONTENT.length > 0) {
            item.CONTENT.forEach(content => {
              const wins = parseInt(content.ZSC) || 0;

              // 格式化日期为 yy-MM
              let dateLabel = "";
              if (item.STARTDATE) {
                const dateStr = item.STARTDATE;
                const dateParts = dateStr.split("-");
                if (dateParts.length >= 2) {
                  const year = dateParts[0].substring(2);
                  const month = dateParts[1];
                  dateLabel = `${year}-${month}`;
                } else {
                  dateLabel = dateStr.substring(0, 5);
                }
              } else {
                dateLabel = `比赛${index + 1}`;
              }

              winsData.push({
                label: dateLabel,
                wins: wins
              });
            });
          }
        });
      }

      // 如果没有真实数据，使用测试数
      if (winsData.length === 0) {
        winsData = [
          { label: "起点", wins: 0, isStart: true },
          { label: "25-01", wins: 5 },
          { label: "25-02", wins: 11 },
          { label: "25-03", wins: 17 },
          { label: "25-04", wins: 23 },
          { label: "25-05", wins: 29 },
          { label: "25-06", wins: 35 },
          { label: "25-07", wins: 41 },
          { label: "25-08", wins: 45 },
          { label: "25-09", wins: 52 },
          { label: "25-10", wins: 60 }
        ];
      }

      if (winsData.length === 0) return;

      const padding = 60;
      const chartWidth = canvas.width - 2 * padding;
      const chartHeight = canvas.height - 2 * padding;

      // 绘制背景
      ctx.fillStyle = "#fafafa";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 计算最大值用于Y轴刻
      const maxWins = Math.max(...winsData.map(d => d.wins));
      const yAxisMax = Math.ceil(maxWins / 10) * 10 || 10; // 向上取整0的倍数，最0

      // 绘制网格和Y轴标
      ctx.strokeStyle = "#e8e8e8";
      ctx.lineWidth = 1;
      ctx.fillStyle = "#999";
      ctx.font = "12px Arial";
      ctx.textAlign = "right";

      for (let i = 0; i <= 5; i++) {
        const y = padding + (chartHeight / 5) * i;
        ctx.beginPath();
        ctx.moveTo(padding, y);
        ctx.lineTo(canvas.width - padding, y);
        ctx.stroke();
        const value = yAxisMax - (i * yAxisMax) / 5;
        ctx.fillText(Math.round(value).toString(), padding - 10, y + 4);
      }

      // 如果只有一个数据点
      if (winsData.length === 1) {
        const x = canvas.width / 2;
        const wins = winsData[0].wins;
        const y = canvas.height - padding - (wins / yAxisMax) * chartHeight;

        ctx.fillStyle = "#10b981";
        ctx.beginPath();
        ctx.arc(x, y, 6, 0, 2 * Math.PI);
        ctx.fill();

        ctx.fillStyle = "#666";
        ctx.font = "12px Arial";
        ctx.textAlign = "center";
        ctx.fillText(winsData[0].label, x, canvas.height - padding + 20);
        return;
      }

      // 多个数据
      const stepX = chartWidth / (winsData.length - 1);

      // 绘制填充区域
      const gradient = ctx.createLinearGradient(
        0,
        padding,
        0,
        canvas.height - padding
      );
      gradient.addColorStop(0, "rgba(16, 185, 129, 0.2)");
      gradient.addColorStop(1, "rgba(16, 185, 129, 0.05)");

      ctx.beginPath();
      winsData.forEach((data, index) => {
        const x = padding + stepX * index;
        const y =
          canvas.height - padding - (data.wins / yAxisMax) * chartHeight;
        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });
      const lastX = padding + stepX * (winsData.length - 1);
      ctx.lineTo(lastX, canvas.height - padding);
      ctx.lineTo(padding, canvas.height - padding);
      ctx.closePath();
      ctx.fillStyle = gradient;
      ctx.fill();

      // 绘制曲线
      ctx.beginPath();
      winsData.forEach((data, index) => {
        const x = padding + stepX * index;
        const y =
          canvas.height - padding - (data.wins / yAxisMax) * chartHeight;
        if (index === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      });
      ctx.strokeStyle = "#10b981";
      ctx.lineWidth = 3;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.stroke();

      // 保存数据供触摸事件使
      this.currentWinsData = winsData;
      this.winsChartPadding = padding;
      this.winsChartStepX = stepX;
      this.winsChartHeight = chartHeight;

      // X轴标
      ctx.fillStyle = "#666";
      ctx.font = "10px Arial";
      ctx.textAlign = "center";
      winsData.forEach((data, index) => {
        const x = padding + stepX * index;
        const y = canvas.height - padding + 20;
        ctx.fillText(data.label, x, y);
      });

      console.log("=== drawWinsChart completed ===");
    },

    // 绘制触摸点的节点和标
    drawTouchPoint(touchX, chartType = "winrate") {
      let canvas, matchData, padding, stepX, chartHeight, color, valueKey, unit;

      if (chartType === "winrate") {
        canvas = this.$refs.statsCanvas;
        matchData = this.currentMatchData;
        padding = this.chartPadding;
        stepX = this.chartStepX;
        chartHeight = this.chartHeight;
        color = "#185f9b";
        valueKey = "winRate";
        unit = "%";
      } else if (chartType === "score") {
        canvas = this.$refs.scoreCanvas;
        matchData = this.currentScoreData;
        padding = this.scoreChartPadding;
        stepX = this.scoreChartStepX;
        chartHeight = this.scoreChartHeight;
        color = "#f59e0b";
        valueKey = "score";
        unit = "";
      } else if (chartType === "wins") {
        canvas = this.$refs.winsCanvas;
        matchData = this.currentWinsData;
        padding = this.winsChartPadding;
        stepX = this.winsChartStepX;
        chartHeight = this.winsChartHeight;
        color = "#10b981";
        valueKey = "wins";
        unit = "";
      }

      if (!canvas || !matchData) return;

      const ctx = canvas.getContext("2d");

      // 找到最近的数据
      let closestIndex = 0;
      let minDistance = Infinity;

      matchData.forEach((data, index) => {
        const x = padding + stepX * index;
        const distance = Math.abs(x - touchX);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });

      // 只有当触摸点足够接近某个数据点时才显
      if (minDistance > stepX / 2) return;

      const data = matchData[closestIndex];
      const x = padding + stepX * closestIndex;
      const value = data[valueKey];

      // 计算Y坐标 - 根据图表类型使用不同的最大
      let y;
      if (chartType === "winrate") {
        // 胜率固定0-100%
        y = canvas.height - padding - (value / 100) * chartHeight;
      } else {
        // 总得分和胜场使用动态最大值（开始）
        const maxValue = Math.max(...matchData.map(d => d[valueKey]));
        const yAxisMax =
          chartType === "score"
            ? Math.ceil(maxValue / 100) * 100 || 100
            : Math.ceil(maxValue / 10) * 10 || 10;
        y = canvas.height - padding - (value / yAxisMax) * chartHeight;
      }

      // 绘制节点
      // 外圈
      ctx.fillStyle = color
        .replace(")", ", 0.2)")
        .replace("rgb", "rgba")
        .replace("#", "rgba(");
      if (color.startsWith("#")) {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        ctx.fillStyle = `rgba(${r}, ${g}, ${b}, 0.2)`;
      }
      ctx.beginPath();
      ctx.arc(x, y, 10, 0, 2 * Math.PI);
      ctx.fill();

      // 中圈
      ctx.fillStyle = "#fff";
      ctx.beginPath();
      ctx.arc(x, y, 6, 0, 2 * Math.PI);
      ctx.fill();

      // 内圈
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(x, y, 4, 0, 2 * Math.PI);
      ctx.fill();

      // 绘制信息
      const boxWidth = 80;
      const boxHeight = 40;
      let boxX = x - boxWidth / 2;
      const boxY = y - boxHeight - 20;

      // 确保信息框不超出画布边界
      if (boxX < 5) boxX = 5;
      if (boxX + boxWidth > canvas.width - 5)
        boxX = canvas.width - boxWidth - 5;

      // 绘制信息框背
      ctx.fillStyle = color
        .replace(")", ", 0.95)")
        .replace("rgb", "rgba")
        .replace("#", "rgba(");
      if (color.startsWith("#")) {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        ctx.fillStyle = `rgba(${r}, ${g}, ${b}, 0.95)`;
      }
      ctx.beginPath();
      // 手动绘制圆角矩形
      const radius = 6;
      ctx.moveTo(boxX + radius, boxY);
      ctx.lineTo(boxX + boxWidth - radius, boxY);
      ctx.quadraticCurveTo(
        boxX + boxWidth,
        boxY,
        boxX + boxWidth,
        boxY + radius
      );
      ctx.lineTo(boxX + boxWidth, boxY + boxHeight - radius);
      ctx.quadraticCurveTo(
        boxX + boxWidth,
        boxY + boxHeight,
        boxX + boxWidth - radius,
        boxY + boxHeight
      );
      ctx.lineTo(boxX + radius, boxY + boxHeight);
      ctx.quadraticCurveTo(
        boxX,
        boxY + boxHeight,
        boxX,
        boxY + boxHeight - radius
      );
      ctx.lineTo(boxX, boxY + radius);
      ctx.quadraticCurveTo(boxX, boxY, boxX + radius, boxY);
      ctx.closePath();
      ctx.fill();

      // 绘制信息框内
      ctx.fillStyle = "#fff";
      ctx.font = "bold 14px Arial";
      ctx.textAlign = "center";

      if (data.isStart) {
        // 起点只显示标
        ctx.fillText("起点", boxX + boxWidth / 2, boxY + 25);
      } else {
        // 显示数
        const displayValue =
          valueKey === "winRate" ? value.toFixed(1) : Math.round(value);
        ctx.fillText(displayValue + unit, boxX + boxWidth / 2, boxY + 25);
      }
    },

    // 处理触摸开
    handleTouchStart(event, chartType = "winrate") {
      let canvas;
      if (chartType === "winrate") {
        canvas = this.$refs.statsCanvas;
      } else if (chartType === "score") {
        canvas = this.$refs.scoreCanvas;
      } else if (chartType === "wins") {
        canvas = this.$refs.winsCanvas;
      }

      if (!canvas) return;

      const rect = canvas.getBoundingClientRect();
      const touch = event.touches[0];
      const touchX = touch.clientX - rect.left;

      // 重绘图表
      if (chartType === "winrate") {
        this.drawStatsChart();
      } else if (chartType === "score") {
        this.drawScoreChart();
      } else if (chartType === "wins") {
        this.drawWinsChart();
      }

      // 绘制触摸
      this.drawTouchPoint(touchX, chartType);
    },

    // 处理触摸移动
    handleTouchMove(event, chartType = "winrate") {
      // event.preventDefault(); // 防止页面滚动

      let canvas;
      if (chartType === "winrate") {
        canvas = this.$refs.statsCanvas;
      } else if (chartType === "score") {
        canvas = this.$refs.scoreCanvas;
      } else if (chartType === "wins") {
        canvas = this.$refs.winsCanvas;
      }

      if (!canvas) return;

      const rect = canvas.getBoundingClientRect();
      const touch = event.touches[0];
      const touchX = touch.clientX - rect.left;

      // 重绘图表
      if (chartType === "winrate") {
        this.drawStatsChart();
      } else if (chartType === "score") {
        this.drawScoreChart();
      } else if (chartType === "wins") {
        this.drawWinsChart();
      }

      // 绘制触摸
      this.drawTouchPoint(touchX, chartType);
    },

    // 处理触摸结束
    handleTouchEnd(chartType = "winrate") {
      // 重绘图表，移除触摸点
      if (chartType === "winrate") {
        this.drawStatsChart();
      } else if (chartType === "score") {
        this.drawScoreChart();
      } else if (chartType === "wins") {
        this.drawWinsChart();
      }
    }
  }
};
</script>

<style scoped>
.athlete-growth-page {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding-bottom: 20px;
}

/* 顶部导航*/
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  position: relative;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #185f9b;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  left: 16px;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.header-right {
  color: #185f9b;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
}

.header-right:hover {
  transform: scale(1.1);
  color: #667eea;
}

/* 球员选择区域 */
.player-selection-section {
  margin: 16px;
  margin-bottom: 8px;
}

.player-list-container {
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%);
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(24, 95, 155, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.player-avatars {
  display: flex;
  align-items: center;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.player-avatars::-webkit-scrollbar {
  height: 4px;
}

.player-avatars::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2px;
}

.player-avatars::-webkit-scrollbar-thumb {
  background: #185f9b;
  border-radius: 2px;
}

.player-avatar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 70px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  padding: 8px;
  border-radius: 12px;
}

.player-avatar-item:hover {
  background: rgba(255, 255, 255, 0.6);
  transform: translateY(-2px);
}

.player-avatar-item.active {
  background: rgba(24, 95, 155, 0.1);
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.2);
}

.player-avatar {
  border: 3px solid transparent;
  transition: all 0.3s ease;
}

.player-avatar-item.active .player-avatar {
  border-color: #185f9b;
  box-shadow: 0 0 0 2px rgba(24, 95, 155, 0.3);
}

.player-name {
  font-size: 12px;
  color: #666;
  margin-top: 6px;
  text-align: center;
  font-weight: 500;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.player-avatar-item.active .player-name {
  color: #185f9b;
  font-weight: 600;
}

.active-indicator {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 12px;
  height: 12px;
  background: #185f9b;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* 删除球员按钮 */
.delete-player-btn {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: #ee0a24;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(238, 10, 36, 0.4);
  z-index: 10;
}

.player-avatar-item:hover .delete-player-btn {
  opacity: 1;
}

.delete-player-btn:hover {
  background: #c8102e;
  transform: scale(1.1);
}

.delete-player-btn:active {
  transform: scale(0.95);
}

.add-player-avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 70px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px;
  border-radius: 12px;
}

.add-player-avatar:hover {
  background: rgba(255, 68, 68, 0.1);
  transform: translateY(-2px);
}

.add-avatar-btn {
  width: 50px;
  height: 50px;
  border: 2px dashed #185f9b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
}

.add-player-avatar:hover .add-avatar-btn {
  border-color: #ff4444;
  background: rgba(255, 68, 68, 0.1);
}

.add-avatar-btn .van-icon {
  color: #185f9b;
  transition: color 0.3s ease;
}

.add-player-avatar:hover .add-avatar-btn .van-icon {
  color: #ff4444;
}

.add-player-text {
  font-size: 12px;
  color: #666;
  margin-top: 6px;
  text-align: center;
  font-weight: 500;
}

.add-player-avatar:hover .add-player-text {
  color: #ff4444;
}

.current-player-info {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(24, 95, 155, 0.2);
  text-align: center;
}

.current-player-label {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}

.current-player-name {
  font-size: 14px;
  color: #185f9b;
  font-weight: 600;
}

/* 运动员信息卡*/
.athlete-info-card {
  background: #fff;
  margin: 16px;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.avatar-section {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.avatar-container {
  position: relative;
  margin-right: 16px;
}

.status-dot {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 3px solid #fff;
}

.status-dot.active {
  background: #52c41a;
  animation: pulse 2s infinite;
}

.info-text h3 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.name-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.name-row h3 {
  margin: 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.edit-btn {
  position: absolute;
  right: 27px;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #185f9b 0%, #1a73b8 100%);
  color: #fff;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);
}

.edit-btn:hover {
  background: linear-gradient(135deg, #1a73b8 0%, #2088d4 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(24, 95, 155, 0.4);
}

.edit-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(24, 95, 155, 0.3);
}

.edit-btn span {
  font-weight: 500;
}

.info-tags {
  display: flex;
  gap: 8px;
  margin-bottom: 3px;
}

.career-info {
  margin-top: 3px;
  color: #666;
  font-size: 14px;
}

/* 比赛类型切换卡片 */
.match-type-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  padding: 12px;
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%);
  border-radius: 12px;
  border: 1px solid rgba(24, 95, 155, 0.1);
}

.match-type-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.6);
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  min-height: 80px;
}

.match-type-tab:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.match-type-tab.active {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 6px 20px rgba(24, 95, 155, 0.3);
  transform: translateY(-4px);
}

.tab-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  filter: grayscale(0.5);
}

.match-type-tab.active .tab-icon {
  filter: grayscale(0);
  transform: scale(1.1);
  animation: iconBounce 0.6s ease;
}

.tab-label {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  transition: color 0.3s ease;
}

.match-type-tab.active .tab-label {
  color: #fff;
  font-weight: 700;
}

.tab-indicator {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background: #fff;
  border-radius: 2px;
  animation: slideIn 0.3s ease;
}

/* 图标弹跳动画 */
@keyframes iconBounce {
  0%,
  100% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.2);
  }
}

/* 指示器滑入动*/
@keyframes slideIn {
  from {
    width: 0;
    opacity: 0;
  }
  to {
    width: 30px;
    opacity: 1;
  }
}

.achievement-stats {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.stat-item {
  text-align: center;
  padding: 16px 12px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  transition: transform 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-2px);
}

.stat-item.success {
  background: linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%);
}

.stat-item.warning {
  background: linear-gradient(135deg, #fffbe6 0%, #fff1b8 100%);
}

.stat-item.info {
  background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
}

.stat-item.primary {
  background: linear-gradient(135deg, #f0f5ff 0%, #d6e4ff 100%);
}

.stat-item.danger {
  background: linear-gradient(135deg, #fff2f0 0%, #ffccc7 100%);
}

.stat-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: #185f9b;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #999;
}

/* 年份筛选器 */
.year-filter-section {
  margin-bottom: 16px;
}

.year-filter-container {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 16px 0;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.year-filter-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 0 16px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox - 隐藏滚动*/
  -ms-overflow-style: none; /* IE and Edge - 隐藏滚动*/
}

/* Chrome, Safari, Opera - 隐藏滚动*/
.year-filter-scroll::-webkit-scrollbar {
  display: none;
}

.year-item {
  flex-shrink: 0;
  min-width: 80px;
  padding: 10px 20px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  text-align: center;
}

.year-item:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.year-item.active {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 16px rgba(24, 95, 155, 0.3);
  transform: translateY(-2px);
}

.year-text {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  display: block;
  transition: color 0.3s ease;
}

.year-item.active .year-text {
  color: #fff;
}

.year-indicator {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 3px;
  background: #fff;
  border-radius: 2px;
}

/* 区块标题 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

/* 成长轨迹 */
.growth-timeline {
  background: #fff;
  margin: 0 16px 16px;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

/* 空数据提*/
.empty-timeline {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.empty-icon {
  margin-bottom: 20px;
  opacity: 0.5;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.empty-text {
  font-size: 16px;
  font-weight: 600;
  color: #666;
  margin-bottom: 8px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.empty-hint {
  font-size: 14px;
  color: #999;
  line-height: 1.6;
  max-width: 280px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.timeline-container {
  position: relative;
}

.timeline-item {
  position: relative;
  margin-bottom: 32px;
  display: flex;
  align-items: flex-start;
}

.timeline-item:nth-child(1) {
  animation-delay: 0.1s;
}
.timeline-item:nth-child(2) {
  animation-delay: 0.2s;
}
.timeline-item:nth-child(3) {
  animation-delay: 0.3s;
}

.timeline-item:last-child {
  margin-bottom: 0;
}

.timeline-line {
  position: absolute;
  left: 25px;
  top: 50px;
  width: 2px;
  height: 60px;
  background: linear-gradient(to bottom, #ddd, #f0f0f0);
  z-index: 1;
}

.timeline-node {
  position: relative;
  z-index: 2;
  margin-right: 20px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.node-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  box-shadow: 0 4px 12px rgba(24, 95, 155, 0.3);
  order: 1;
}

.timeline-item.active .node-icon {
  background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.3);
}

.node-date {
  text-align: center;
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  font-weight: 500;
  order: 2;
}

.timeline-content {
  flex: 1;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 20px;
  border-radius: 12px;
  border-left: 4px solid #185f9b;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  backface-visibility: hidden;
  transform: translateZ(0);
}

.timeline-item.active .timeline-content {
  border-left-color: #52c41a;
  background: linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%);
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.content-header h4 {
  margin: 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 排名标题样式 */
.rank-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rank-icon {
  font-size: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: medalShine 2s ease-in-out infinite;
}

/* 金牌动画 */
.gold-medal {
  filter: drop-shadow(0 2px 4px rgba(255, 215, 0, 0.5));
}

/* 银牌动画 */
.silver-medal {
  filter: drop-shadow(0 2px 4px rgba(192, 192, 192, 0.5));
}

/* 铜牌动画 */
.bronze-medal {
  filter: drop-shadow(0 2px 4px rgba(205, 127, 50, 0.5));
}

/* 奖牌闪光动画 */
@keyframes medalShine {
  0%,
  100% {
    transform: scale(1);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.1);
    filter: brightness(1.2);
  }
}

/* 数据统计卡片 */
.stats-summary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.stats-summary-item {
  background: rgba(255, 255, 255, 0.8);
  padding: 12px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.stats-summary-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stats-label {
  font-size: 12px;
  color: #999;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.stats-value {
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.stats-unit {
  font-size: 11px;
  color: #999;
  margin-left: 2px;
}

/* 数值高亮颜*/
.highlight-primary {
  color: #185f9b;
}

.highlight-success {
  color: #52c41a;
}

.highlight-warning {
  color: #faad14;
}

.highlight-info {
  color: #1890ff;
}

.achievement-details {
  margin-bottom: 16px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

/* 参赛项目标题 */
.achievement-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(24, 95, 155, 0.2);
}

.achievement-title .van-icon {
  color: #185f9b;
  font-size: 16px;
}

/* 参赛项目列表 */
.achievement-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.achievement-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
}

.achievement-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.95);
}

.achievement-item:active {
  transform: translateX(2px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.achievement-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(255, 215, 0, 0.3);
}

.achievement-icon .van-icon {
  color: #8b5a00;
}

.achievement-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.achievement-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.achievement-type {
  font-size: 12px;
  color: #999;
  line-height: 1.2;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 箭头图标 */
.achievement-arrow {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.achievement-item:hover .achievement-arrow {
  transform: translateX(4px);
}

.skill-improvement {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  padding-top: 16px;
}

.skill-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  font-weight: 500;
}

.skill-progress {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skill-bar {
  display: flex;
  align-items: center;
  gap: 8px;
}

.skill-name {
  width: 40px;
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.skill-bar-bg {
  flex: 1;
  height: 6px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 3px;
  overflow: hidden;
}

.skill-bar-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.8s ease;
}

.skill-bar-fill.primary {
  background: linear-gradient(90deg, #185f9b, #1a6ba8);
}
.skill-bar-fill.warning {
  background: linear-gradient(90deg, #faad14, #ffc53d);
}
.skill-bar-fill.success {
  background: linear-gradient(90deg, #52c41a, #73d13d);
}
.skill-bar-fill.danger {
  background: linear-gradient(90deg, #f5222d, #ff4d4f);
}

.skill-value {
  width: 30px;
  font-size: 11px;
  color: #185f9b;
  font-weight: 600;
  text-align: right;
}

/* 年度统计 */
.yearly-stats {
  background: #fff;
  margin: 0 16px 16px;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.chart-legend {
  display: flex;
  gap: 16px;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.legend-dot.winrate {
  background: #185f9b;
  box-shadow: 0 0 0 3px rgba(24, 95, 155, 0.2);
}

.legend-dot.score {
  background: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.2);
}

.legend-dot.wins {
  background: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
}

.stats-chart {
  display: flex;
  justify-content: center;
  background: linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%);
  border-radius: 12px;
  padding: 20px;
  margin-top: 16px;
  border: 1px solid #e8e8e8;
}

/* 空图表提*/
.empty-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}

.empty-chart .empty-icon {
  margin-bottom: 12px;
  opacity: 0.5;
}

.empty-chart .empty-text {
  font-size: 14px;
  color: #999;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 动画效果 */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0.7);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(82, 196, 26, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(82, 196, 26, 0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

/* 响应式设*/
@media (max-width: 768px) {
  .player-list-container {
    padding: 12px;
  }

  .player-avatars {
    gap: 12px;
  }

  .player-avatar-item,
  .add-player-avatar {
    min-width: 60px;
    padding: 6px;
  }

  .player-avatar,
  .add-avatar-btn {
    width: 40px !important;
    height: 40px !important;
  }

  .player-name,
  .add-player-text {
    font-size: 11px;
    max-width: 50px;
  }

  .current-player-info {
    margin-top: 8px;
    padding-top: 8px;
  }

  .current-player-label,
  .current-player-name {
    font-size: 13px;
  }

  /* 比赛类型切换卡片响应*/
  .match-type-tabs {
    gap: 8px;
    padding: 8px;
  }

  .match-type-tab {
    padding: 12px 8px;
    min-height: 70px;
  }

  .tab-icon {
    font-size: 28px;
    margin-bottom: 6px;
  }

  .tab-label {
    font-size: 12px;
  }

  .tab-indicator {
    width: 24px;
    bottom: 6px;
  }

  .achievement-stats {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }

  .athlete-info-card {
    margin: 12px;
    padding: 20px;
  }

  .growth-timeline,
  .yearly-stats {
    margin: 0 12px 12px;
    padding: 20px;
  }

  .empty-timeline {
    padding: 50px 20px;
  }

  .empty-icon .van-icon {
    font-size: 56px;
  }

  .empty-text {
    font-size: 15px;
  }

  .empty-hint {
    font-size: 13px;
  }

  .timeline-content {
    padding: 16px;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

@media (max-width: 320px) {
  /* 超小屏幕下的比赛类型切换 */
  .match-type-tabs {
    gap: 6px;
    padding: 6px;
  }

  .match-type-tab {
    padding: 10px 6px;
    min-height: 65px;
  }

  .tab-icon {
    font-size: 24px;
    margin-bottom: 4px;
  }

  .tab-label {
    font-size: 11px;
  }

  .tab-indicator {
    width: 20px;
    height: 2px;
    bottom: 4px;
  }
}

/* 小屏幕优- 480px以下 */
@media (max-width: 480px) {
  .achievement-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .stat-item {
    padding: 12px 8px;
  }

  .stat-icon {
    font-size: 20px;
    margin-bottom: 6px;
  }

  .stat-number {
    font-size: 20px;
  }

  .stat-label {
    font-size: 11px;
  }
}

/* 会员推广横幅 */
.vip-promotion-banner {
  margin: 16px 16px 20px 16px;
  cursor: pointer;
  animation: slideInDown 0.6s ease-out;
}

.vip-banner-bg {
  position: relative;
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 50%,
    rgb(44, 135, 195) 100%
  );
  border-radius: 16px;
  padding: 20px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(24, 95, 155, 0.4),
    0 4px 12px rgba(34, 115, 175, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.vip-banner-bg::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 70%
  );
  animation: vipRotate 8s linear infinite;
}

.vip-promotion-banner:hover .vip-banner-bg {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 32px rgba(24, 95, 155, 0.5),
    0 6px 16px rgba(34, 115, 175, 0.4);
}

.vip-promotion-banner:active .vip-banner-bg {
  transform: translateY(-2px) scale(1.01);
}

.vip-banner-content {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 1;
}

.vip-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

.vip-icon {
  color: #fff;
  animation: vipIconPulse 2s ease-in-out infinite;
}

.vip-sparkle {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 20px;
  animation: vipSparkle 1.5s ease-in-out infinite;
}

.vip-text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.vip-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
}

.vip-highlight {
  background: linear-gradient(90deg, #fff 0%, #e0f7ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: vipTextShine 3s ease-in-out infinite;
}

.vip-separator {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}

.vip-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.vip-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.vip-promotion-banner:hover .vip-arrow {
  transform: translateX(4px);
  background: rgba(255, 255, 255, 0.3);
}

.vip-banner-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: vipShine 3s ease-in-out infinite;
}

/* 会员横幅动画 */
@keyframes slideInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes vipRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes vipIconPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes vipSparkle {
  0%,
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.2) rotate(180deg);
  }
}

@keyframes vipTextShine {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes vipShine {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}

/* 返回顶部悬浮按钮 */
.back-to-top-fab {
  position: fixed;
  bottom: 100px;
  right: 20px;
  width: 46px;
  height: 46px;
  background: linear-gradient(
    135deg,
    rgb(24, 95, 155) 0%,
    rgb(34, 115, 175) 50%,
    rgb(44, 135, 195) 100%
  );
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 20px rgba(24, 95, 155, 0.5), 0 0 0 0 rgba(24, 95, 155, 0.4);
  cursor: pointer;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fabPulse 2s ease-in-out infinite;
}

.back-to-top-fab:hover {
  transform: translateY(-8px) scale(1.1);
  box-shadow: 0 10px 30px rgba(24, 95, 155, 0.7),
    0 0 0 8px rgba(24, 95, 155, 0.1);
}

.back-to-top-fab:active {
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 6px 20px rgba(24, 95, 155, 0.6);
}

.fab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
}

.fab-icon .van-icon {
  color: #fff;
  font-weight: bold;
}

.fab-text {
  font-size: 10px;
  color: #fff;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* 悬浮按钮脉冲动画 */
@keyframes fabPulse {
  0%,
  100% {
    box-shadow: 0 6px 20px rgba(24, 95, 155, 0.5),
      0 0 0 0 rgba(24, 95, 155, 0.4);
  }
  50% {
    box-shadow: 0 6px 20px rgba(24, 95, 155, 0.5),
      0 0 0 10px rgba(24, 95, 155, 0);
  }
}

/* 淡入缩放过渡动画 */
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.5) translateY(20px);
}

.fade-scale-enter-to,
.fade-scale-leave {
  opacity: 1;
  transform: scale(1) translateY(0);
}
</style>



// WEBPACK FOOTER //
// src/components/MeIndex/MeQygjIndex.vue